import React from "react";
import { Modal, Button } from "react-bootstrap";
import {useTranslation} from "react-i18next";


export const DeleteAlerts = ({ show, rule, onClose, onConfirm }: any) => {
    const {t} = useTranslation();
    return (
        <Modal show={show} onHide={onClose} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('RuleList.delete_alerts')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {t('RuleList.delete_alerts_description')}
                <strong> {rule?.name}</strong>?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={onClose}>{t('RuleList.cancel')}</Button>
                <Button variant="primary" onClick={onConfirm}>{t('RuleList.delete')}</Button>
            </Modal.Footer>
        </Modal>
    );
};